export default __webpack_public_path__ + "static/media/new-10.26eaceaa.png";